import * as React from 'react';
import { updateSearchFilterValue } from '../mutators/searchViewMutators';
import type { SearchFilterOption } from 'owa-timestream-asset-search';

export default function useCheckboxSearchRefinerState({ option }: { option: SearchFilterOption }) {
    const onChange = React.useCallback(
        (ev: React.FormEvent<HTMLDivElement>, checked: boolean) => {
            updateSearchFilterValue(option.id, checked);
        },
        [option.id]
    );

    return {
        onChange: onChange,
    };
}
